import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { connect } from "react-redux";

function SkeletonCard(props) {
  let baseColor = props.themes !== "light" ? "#202020" : "#e4e4e4";
  let highColor = props.themes !== "light" ? "#444" : "#ffffff";
  return (
    <div className="px-10 py-4 flex flex-row gap-2">
      <div className="px-10">
        <SkeletonTheme width="4rem" height="4rem" baseColor={baseColor} highlightColor={highColor}>
          <p>
            <Skeleton circle={true} />
          </p>
        </SkeletonTheme>
      </div>
      <div className="flex-1 pr-10">
        <SkeletonTheme inline={true} baseColor={baseColor} highlightColor={highColor}>
          <p>
            <Skeleton count={3} />
          </p>
        </SkeletonTheme>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    themes: state.darkmode.theme,
  };
};

export default connect(mapStateToProps)(SkeletonCard);
